export class OAuthApiService {
  constructor(http) {
    this.endpoint = '';
    this.http = http;
    this.clientSecret = 'WJC4eSpLDGtdtcyh0NfuwCNk6PtCZH1U9vNh0Hu7';
  }

  async getToken(username, password) {
    const { data } = await this.http.post('/oauth', { username, password });
    return data;
  }

  async getTokenByForm(username, password) {
    const body = { 
      username, 
      password,
      grant_type: 'password',
      client_id: 2,
      client_secret: this.clientSecret,
    };
    const { access_token } = await this.http.post('/token/', body);
    return access_token;
  }

  async getTokenByOAuthToken(social, token, redirectUrl) {
    const body = { 
      backend: social,
      grant_type: 'convert_token',
      client_id: 2,
      client_secret: this.clientSecret,
      token,
      redirect_uri: redirectUrl,
    };
    const headers = { Authorization: 'NoAuth' };
    const { data } = await axios.post('/convert-token/', body, { headers });
    return data.access_token;
  }
}
